import React from 'react'

import classes from './EmpDetailHeader.scss'

import CardHeader from '../../../../UI/Card/Header/Header'
import { withTranslate } from 'react-redux-multilingual'

const empDetailHeader = ({ pageAction, translate }) => {
  const capitalizedText = pageAction[0].toUpperCase() + pageAction.slice(1)
  return (
    <CardHeader className={classes.Header}>
      <div className={classes.EmpDetailHeader}>{capitalizedText + translate('profile')}</div>
    </CardHeader>
  )
}

export default withTranslate(empDetailHeader)
